import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

export function connect() {
    if (!window.Echo) {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_APP_KEY,
            cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
            encrypted: true,
            authEndpoint: process.env.VUE_APP_API_BASE_URL + 'api/broadcasting/auth',
            auth: {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
        })
        window.Echo.connector.pusher.connection.bind(
            'connected',
            (event) => {
              console.log('pusher bind connected')
              connect(event)
            }
        )
        window.Echo.connector.pusher.connection.bind(
            'disconnected',
            () => {
              console.log('pusher bind disconnected')
              disconnect()
            }
        )
    }

    window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
    window.Echo.connector.pusher.connect()
}

export function disconnect() {
    if (!window.Echo) {
      return
    }

    window.Echo.disconnect()
}

connect()
